import { z } from 'zod';

type AnySchema = z.ZodType;

function withoutDefault(schema: AnySchema): AnySchema {
  const def = (schema as { def: { type: string; innerType?: AnySchema } }).def;
  if ((def.type === 'default' || def.type === 'prefault') && def.innerType) return withoutDefault(def.innerType);
  if (def.type === 'optional' && def.innerType) return withoutDefault(def.innerType).optional();
  if (def.type === 'nullable' && def.innerType) return withoutDefault(def.innerType).nullable();
  return schema;
}

/**
 * `.partial()` para PATCH. No zod 4 um campo com `.default()` continua recebendo o default quando
 * a chave falta, mesmo depois de `.partial()`; num PATCH isso sobrescreveria o valor salvo.
 * Aqui os defaults saem antes, então campo ausente continua ausente.
 */
export function patchOf<T extends z.ZodObject>(schema: T): ReturnType<T['partial']> {
  const shape = Object.fromEntries(Object.entries(schema.shape).map(([key, field]) => [key, withoutDefault(field as AnySchema)]));
  return schema.extend(shape).partial() as ReturnType<T['partial']>;
}
